import React from 'react'
import { useSelector } from 'react-redux'
import { FiArchive, FiMoreVertical, FiRotateCcw } from 'react-icons/fi'
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton
} from '@chakra-ui/react'
import { canManageDiscountArchive, GetNotification } from '../../Utils'
import { useMutateDiscounts } from '../../hooks/Discounts'

export default function DiscountActions({ discount, archived = false }) {
  const { user } = useSelector((state) => state.auth)
  const { mutate: archiveDiscount, isLoading: isArchiving } =
    useMutateDiscounts('ARCHIVE')
  const { mutate: restoreDiscount, isLoading: isRestoring } =
    useMutateDiscounts('RESTORE')
  const getErrorMessage = (error, fallback) =>
    error?.response?.data?.message || fallback

  const handleArchive = (discount, reason) => {
    archiveDiscount(
      { discountId: discount._id, reason },
      {
        onSuccess: () =>
          GetNotification.basic('Descuento archivado con éxito', 'Aceptar'),
        onError: (error) =>
          GetNotification.basic(
            'Error',
            'Aceptar',
            getErrorMessage(error, 'No fue posible archivar el descuento'),
            'error'
          )
      }
    )
  }

  const questionArchive = (discount) => {
    GetNotification.questionWithInput(
      '¿Archivar este descuento?',
      (reason) => handleArchive(discount, reason),
      'El descuento dejará de aparecer en la lista de registros activos.',
      'Motivo del archivado'
    )
  }

  const handleRestore = (discount) => {
    restoreDiscount(discount._id, {
      onSuccess: () =>
        GetNotification.basic('Descuento restaurado con éxito', 'Aceptar'),
      onError: (error) =>
        GetNotification.basic(
          'Error',
          'Aceptar',
          getErrorMessage(error, 'No fue posible restaurar el descuento'),
          'error'
        )
    })
  }

  const questionRestore = (discount) => {
    GetNotification.question(
      '¿Restaurar este descuento?',
      () => handleRestore(discount),
      null,
      'Volverá a aparecer en la lista de descuentos activos.',
      'question'
    )
  }

  if (!canManageDiscountArchive(user)) return null
  return (
    <Menu isLazy>
      <MenuButton
        as={IconButton}
        aria-label="Acciones del descuento"
        icon={<FiMoreVertical />}
        variant="ghost"
        isDisabled={isArchiving || isRestoring}
      />
      <MenuList minW="180px">
        <MenuItem
          icon={archived ? <FiRotateCcw /> : <FiArchive />}
          onClick={() =>
            archived ? questionRestore(discount) : questionArchive(discount)
          }
        >
          {archived ? 'Restaurar' : 'Archivar'}
        </MenuItem>
      </MenuList>
    </Menu>
  )
}
